<template>
  <v-select
    v-model="localSelection"
    :items="availableSites"
    hide-selected
    :loading="sitesLoading"
    outlined
    dense
    hide-details
    item-text="name"
    item-value="id"
    v-on:change="emitNewValue"
  >
  </v-select>
</template>
<script>
export default {
  data() {
    return {
      localSelection: undefined,
      sites: []
    };
  },
  props: {
    sitesLoading: Boolean,
    selectedSite: String,
    allSites: Array,
    selectedSites: Array
  },
  computed: {
    availableSites() {
      return this.allSites.filter(
        s =>
          !this.selectedSites.find(siteId => siteId === s.id) ||
          s.id === this.localSelection
      );
    }
  },
  methods: {
    emitNewValue() {
      this.$emit("site-selected", this.localSelection);
    }
  },
  watch: {
    selectedSite: {
      handler(newValue) {
        this.localSelection = newValue;
      },
      immediate: true
    }
  }
};
</script>
